import React, { useEffect, useRef } from "react";
import Lenis from "@studio-freight/lenis";
import Hero from "@/components/sections/Hero";
import EditorialRibbon from "@/components/sections/EditorialRibbon";
import Craftsmanship from "@/components/sections/Craftsmanship";
import Pairings from "@/components/sections/Pairings";
import Testimonial from "@/components/sections/Testimonial";
import FranchiseBand from "@/components/sections/FranchiseBand";
import Concierge from "@/components/sections/Concierge";
import Footer from "@/components/sections/Footer";
import Nav from "@/components/sections/Nav";

export default function Landing() {
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.35,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        lenisRef.current = lenis;
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        const id = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(id);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="grain bg-obsidian-900 text-ice-50 min-h-screen relative" data-testid="landing-root">
            <Nav />
            <Hero />
            <EditorialRibbon />
            <Craftsmanship />
            <Pairings />
            <Testimonial />
            <FranchiseBand />
            <Concierge />
            <Footer />
        </div>
    );
}
